import React from "react";

import { IoIosArrowBack } from "react-icons/io";
import {
  useGetContactUsQuery,
  useGetPrivacyPolicyQuery,
  useGetTermsAndConditionQuery,
} from "../../Data/services/settingApi";
import ChangePassword from "./ChangePassword";
import ContactUs from "./ContactUs";
import { ROUTES } from "./contants";
import EditProfile from "./EditProfile";
import PrivacyPolicy from "./PrivacyPolicy";
import styles from "./styles/Details.module.scss";
import TermsAndConditions from "./TermsAndConditions";

export default function Details({ isMobile = false, route = "", setRoute }) {
  const handleBackButtonClck = () => {
    setRoute("");
  };

  const {
    data: termsData,
    isSuccess: tSuccess,
    isLoading: tLoading,
    isFetching: tFetching,
    refetch: tRefetch,
  } = useGetTermsAndConditionQuery({ refetchOnMountOrArgChange: true });
  const {
    data: privacyData,
    isSuccess: pSuccess,
    isLoading: pLoading,
    isFetching: pFetching,
    refetch: pRefetch,
  } = useGetPrivacyPolicyQuery({ refetchOnMountOrArgChange: true });
  const {
    data: contactData,
    isSuccess: cSuccess,
    isLoading: cLoading,
    isFetching: cFetching,
    refetch: cRefetch,
  } = useGetContactUsQuery({ refetchOnMountOrArgChange: true });

  return (
    <div className={styles.Details}>
      {!isMobile ? (
        ""
      ) : (
        <span className={styles.backButton} onClick={handleBackButtonClck}>
          <IoIosArrowBack />
        </span>
      )}
      {route === ROUTES.EDIT_PROFILE ? (
        <EditProfile />
      ) : route === ROUTES.CHANGE_PASSWORD ? (
        <ChangePassword />
      ) : route === ROUTES.TERMS_CONDITIONS ? (
        <TermsAndConditions refetch={tRefetch} />
      ) : route === ROUTES.PRIVACY_POLICY ? (
        <PrivacyPolicy refetch={pRefetch} />
      ) : route === ROUTES.CONTACT_US ? (
        <ContactUs refetch={cRefetch} />
      ) : (
        ""
      )}
    </div>
  );
}
